<mat-toolbar class="header-toolbar" color="primary">
  <!-- Sidebar Toggle Icon -->
  <button mat-icon-button class="header-icon" (click)="onToggleSidebar()" aria-label="Toggle sidebar">
    <mat-icon>menu</mat-icon>
  </button>

  <!-- System Title -->
  <span class="header-title">SISTEMA ARBOR</span>

  <!-- Notification and Profile Icons -->
  <div class="header-actions">
    <button mat-icon-button class="header-icon" (click)="openProfileEditDialog()" aria-label="User Profile">
      <mat-icon>account_circle</mat-icon>
    </button>
  </div>
</mat-toolbar>